import { Button, Modal, Select, InlineNotification, TextBox, ConfirmationModal, Checkbox } from "@veneer/core";
import React, { useState, useEffect } from "react";
import ConnectAPI from "../../../services/api";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import moment from "moment";

const UploadModalDate = (props) => {
    //Variables
    const [endUser, setEndUser] =  useState();
    const [pressID, setPressID] =  useState();
    const [valueOne, setValueOne] =  useState(0);
    const [valueTwo, setValueTwo] =  useState(0);
    const [valueThree, setValueThree] =  useState(0);
    const [valueFour, setValueFour] =  useState(0);
    const [valueFive, setValueFive] =  useState(0);
    const [valueSix, setValueSix] =  useState(0);
    const [valueSeven, setValueSeven] =  useState(0);
    const [valueEight, setValueEight] =  useState(0);
    const connectApi = new ConnectAPI();
    const { t } = useTranslation();
    const [showNotification, setShowNotification] = useState(false);
    const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
    const [endDate, setEndDate] = useState();
    const [dateSelected, setDateSelected] = useState();
    const [showButton, setShowButton] = useState(false);
    const [channelSelected, setChannelSelected] = useState();
    const [channelView, setChannelView] = useState([]);
    const [endUserView, setEndUserView] = useState([]);
    const [pressView, setPressView] = useState([]);
    const [reloadButton, setReloadButton] = useState(false);
    const [dataView, setDataView] = useState([]);
    const [confirButton, setConfirButton] = useState(false);
    const [dataGlobal, setDataGlobal] = useState([]);
    const [channel, setChannel] = useState();
    const [user, setUser] = useState();
    const [activate, setActivate] = useState(false);
    const [lastEndDate, setLastEndDate] = useState();
    const [modifyBtn, setModifyBtn] = useState(true);
    const [modifyLastGT, setModifyLastGT] = useState(true);
    const [seriesData, setSeriesData] = useState(false);
    const [series4Check, setSeries4Check] = useState(false);
    const [pressList, setPressList] = useState([]);
    const [press, setPress] = useState([]);
    const [pressCheck, setPressCheck] = useState(false);

    //Metodos
    useEffect(() => {
        if( props.showModal === true ){
            if( props.dataList.length > 0 ){
                setDataView(props.dataList);
                const listChannel = [ ...new Set(props.dataList.map((item) => item.channel)) ];
                let valueOpt = [];
                for (let i = 0; i < listChannel.length; i++)
                    valueOpt.push({ value: i, label: listChannel[i] });
                setChannelView( valueOpt );
            }
            if( props.tabView === 'global_tier' ){
                setDataGlobal(props.dataGlobal);
                if(props.valueModify){
                    setPress(props.itemModify.idPressList);
                    if(props.itemModify.series4OtherClick > 0 | props.itemModify.series4BlackClick > 0 | props.itemModify.series4OneShotClick > 0 | props.itemModify.series4WhiteClick > 0)
                        setSeries4Check(true);
                }
            }
            if( props.tabView === 'rate' & props.btnChange ){
                setValueOne( props.dataModify.indigoRate );
                setValueTwo( props.dataModify.ptaxAverage );
            }
            if (  props.tabView === 'lsMark'  ) {
                setValueOne( moment(new Date( new Date(props.dateInit))).format("YYYY") );
                setValueTwo( moment(new Date( new Date(props.dateInit))).format("MM") );
            }
            setDateSelected( props.dateInit );
            setEndDate( moment(new Date( new Date(props.dateInit).getFullYear(), new Date(props.dateInit).getMonth()+1, 0 )).format("MM-DD-YYYY") );
        }
    }, [props.showModal]);

    const uploadAllData = () => {
        let flag = false;
        if ( props.tabView === 'global_tier' ) {
            let filterStartDate = [];
            filterStartDate = dataGlobal.filter( x => new Date(dateSelected).getTime() === new Date(x.startDate).getTime() & channel === x.channel & user === x.name & press === x.idPressList );
            if ( filterStartDate.length != 0 ){
                setNotificationDetails({
                    title: t("notifyWrongRegistered"),
                    type: 'negative',
                    description: t("notifyRegistered")
                });
                setShowNotification(true);
            }else if ( new Date(dateSelected) >= new Date(endDate) ){
                setNotificationDetails({
                    title: t("notifyWrongDate"),
                    type: 'negative',
                    description: t("notifyDatesValue")
                });
                setShowNotification(true);
            }else if ( valueOne < 0 | valueTwo < 0 | valueThree < 0 | valueFour < 0 | 
                valueOne >= 1 | valueTwo >= 1 | valueThree >= 1 | valueFour >= 1 ){
                    setNotificationDetails({
                        title: t("notifyWrongValues"),
                        type: 'negative',
                        description: t("notifyDecimalValues")
                    });
                    setShowNotification(true);
            } else {
                let filterData = dataGlobal.filter( x => new Date(dateSelected) >= new Date(x.startDate)
                        & new Date(dateSelected) <= new Date(x.endDate) & channel === x.channel & user === x.name );
                if ( filterData.length != 0 ){
                    /*setLastEndDate( moment(new Date( new Date(props.dateInit).getFullYear(), new Date(props.dateInit).getMonth(), 0 )).format("MM-DD-YYYY") );
                    props.setShowModal(false);
                    setConfirButton(true);
                    setActivate(true);*/
                    flag = true;
                } else
                    flag = true;
            }
        
        } else if ( props.tabView === 'rate' ) {
            if ( valueOne <= 0 | valueTwo <= 0 | valueOne % 1 === 0 | valueTwo % 1 === 0){
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("notifyDecimalValues")
                });
                setShowNotification(true);
            }else
                flag = true;
        } else if ( props.tabView === 'run_Length' ) { 
            if ( valueOne <= 0 | valueOne % 1 !== 0 ){
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("notifyIntergerValues")
                });
                setShowNotification(true);
            } else
                flag = true;
        } else if ( props.tabView === 'lsMark' ) { 
            if ( valueThree <= 0 ){
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("notifyNegativeOrCero")
                });
                setShowNotification(true);
            } else
                flag = true;
        }
        uploadAllDataButton(flag);
    }

    function uploadAllDataButton(flag){
        if ( flag ){
            let data = new FormData();
            data.append( "TabView", props.tabView );
            if ( props.tabView === 'global_tier' ) {
                if(props.valueModify){
                    data.append("StartDate", moment(props.itemModify.startDate).format("MM-DD-YYYY"));
                    data.append("SelectedPress", props.idPressList);
                } else {
                    data.append("StartDate", dateSelected);
                    data.append("SelectedPress", press);
                }
                data.append("Modify", props.valueModify);
                data.append("Activate", activate);
                data.append("LastEndDate", lastEndDate);
                data.append("idEndUser", endUser);
                data.append("EndDate", endDate);
                data.append("Serie3MCClick", valueOne);
                data.append("Serie31cClick", valueTwo);
                data.append("Serie32cClick", valueThree);
                data.append("Serie3EPMClick", valueFour);

                data.append("Series4BlackClick", valueFive);
                data.append("Series4OtherClick", valueSix);
                data.append("Series4OneShotClick", valueSeven);
                data.append("Series4WhiteClick", valueEight);

                data.append("Modify", props.valueModify);
            } else if ( props.tabView === 'rate' ) {
                data.append("Date", dateSelected);
                data.append("IndigoRate", valueOne);
                data.append("PtaxAverage", valueTwo);
                data.append("ButtonChange", props.btnChange);
            } else if ( props.tabView === 'run_Length' ) {
                data.append("idSpecialCondition", 1190);//special condition 21 - id = 1190
                data.append("idPress", pressID);
                data.append("MonthYear", dateSelected);
                data.append("TPI", valueOne);
                data.append("Modify", props.valueModify);
            } else if ( props.tabView === 'lsMark' ) {
                data.append("idPress", pressID);
                data.append("Year", valueOne);
                data.append("Month", valueTwo);
                data.append("LSMark", valueThree);
                data.append("Modify", props.valueModify);
            }
            const handleUploadResponse = (status, response) => {
                if (response === 'allGood') {
                    setNotificationDetails({
                        title: t('notifyAllCorrect'),
                        type: 'positive',
                        description: ''
                    });
                    setReloadButton(true);
                    props.setShowModal(false);
                    props.setdatacounter(props.datacounter+1);
                    //window.location.reload(false);
                    setCloseModal();
                } else 
                    setNotificationDetails({
                        title: t("notifyWrognSQL"),
                        type: 'negative',
                        description: t("notifySQLError") + " - " + props.tabView
                    });
                setShowNotification(true);
            }
            connectApi.post(
                "api/Channels/uploadAllData",
                data,
                handleUploadResponse
            ).catch((error) => {
                props.setShowModal(false);
                Swal.fire(
                    "Error " + error.response.status,
                    error.response.data, "error"
                );
            });
        }
    }
    const setListEndUser = (value) => {
        const listEndUser = [ ...new Map(dataView.map((item) => [item.name, [item.channel, item.name, item.idEndUser]])).values() ];
        let i = 0;
        let valueOpt = [];
        listEndUser.forEach(item => {
            if(item[0] === value){
                props.tabView === 'global_tier' 
                    ? valueOpt.push({ value: item[2], label: item[1] })
                    : valueOpt.push({ value: item[1], label: item[1]});
                i ++;
            }
        });
        setEndUserView(valueOpt);
    }
    const setListPressEndUser = (value) => {
        const listPress = [ ...new Map(dataView.map((item) => [item.idPressList, [item.name, item.idPressList]])).values() ].filter(item => item[0] === value);
        let valueOpt = [];
        listPress[0][1].forEach(item => { valueOpt.push({ value: item, label: item }) });
        setPressList(valueOpt);
    }
    const setListPress = (value) => {
        const listPress = [ ...new Map(dataView.map((item) => [item.idPress, [item.name, item.idPress]])).values() ];
        let i = 0;
        let valueOpt = [];
        listPress.forEach(item => {
            if(item[0] === value){
                valueOpt.push({ value: item[1], label: item[1] });
                i ++;
            }
        });
        setPressView(valueOpt);
    }
    const setMontDay = (value) => {
        setEndDate( moment(new Date( new Date(value.target.value).getFullYear(), 
                new Date(value.target.value).getMonth()+1, 0 )).format("MM-DD-YYYY") );
    };
    const setCloseModal = () => {
        if( reloadButton ){
            window.location.reload(false);
            props.setShowModal(false);
        } else{
            props.setShowModal(false);
            setEndDate( moment(new Date( new Date(props.dateInit).getFullYear(), new Date(props.dateInit).getMonth()+1, 0 )).format("MM-DD-YYYY") );
            setChannelSelected(undefined);
            setChannel('');
            setEndUserView([]);
            setEndUser('');
            setValueOne(0);
            setValueTwo(0);
            setValueThree(0);
            setValueFour(0);
            setPressID(undefined);
            setPressView([]);
            setShowButton(false);
            setModifyLastGT(false);
            setModifyBtn(true);
            setPressList([]);
            setPress([]);
        }
        if (!(props.tabView === 'rate'))
            props.setValueModify(false);
        if (  props.tabView === 'lsMark'  ) {
            setValueOne( moment(new Date( new Date(props.dateInit))).format("YYYY") );
            setValueTwo( moment(new Date( new Date(props.dateInit))).format("MM") );
        }

    };
    const setDefaultValues = () => {

        if (props.tabView === 'global_tier'){
            if ( valueOne === undefined | valueOne === '' ){
                setEndUser(props.itemModify.idEndUser);
                setEndDate(moment(props.itemModify.endDate).format("MM-DD-YYYY"));
                setValueOne(props.itemModify.serie3MCClick);
                setValueTwo(props.itemModify.serie31cClick);
                setValueThree(props.itemModify.serie32cClick);
                setValueFour(props.itemModify.serie3EPMClick);
                setValueFive(props.itemModify.series4BlackClick);
                setValueSix(props.itemModify.series4OtherClick);
                setValueSeven(props.itemModify.series4OneShotClick);
                setValueEight(props.itemModify.series4WhiteClick);
                
                if( props.valueModify && new Date(props.dateInit) > new Date(props.itemModify.startDate) ){
                    setModifyLastGT(true);
                }
                    
            }
        }else if (props.tabView === 'rate'){
            if ( valueOne === undefined | valueOne === '' | valueOne == 0 ){
                setValueOne(props.itemModify.indigoRate);
                setValueTwo(props.itemModify.ptaxAverage);
            }
        }else if (props.tabView==='run_Length'){
            if ( channelSelected === undefined | channelSelected === '' ){
                let valueOpt = [];
                channelView.forEach((element)=>{
                    if (element.label===props.itemModify.channel)
                    {   
                        setChannelSelected(element.value);
                        const listEndUser = [ ...new Map(dataView.map((item) => [item.name, [item.channel, item.name, item.idEndUser]])).values() ];
                        let i = 0;
                        listEndUser.forEach(item => {
                            if(item[0] === props.itemModify.channel){
                                valueOpt.push({ value: item[1], label: item[1]});
                                i ++;
                            }
                        });
                        setListEndUser(props.itemModify.channel)
                    }
                });
                valueOpt.forEach((element)=>{
                    if (element.label===props.itemModify.name){
                        setEndUser(element.value); 
                        setListPress(element.label);
                        setPressID(props.itemModify.idPress);
                        setValueOne(props.itemModify.tpi);
                    }
                });
                
            }
        }else if(props.tabView==='lsMark'){
            if ( channelSelected === undefined | channelSelected === ''
                | valueOne === undefined | valueOne === '' | valueOne == 0  ){
                let valueOpt = [];
                channelView.forEach((element)=>{
                    if (element.label===props.itemModify.channel)
                    {   
                        setChannelSelected(element.value);
                        const listEndUser = [ ...new Map(dataView.map((item) => [item.name, [item.channel, item.name, item.idEndUser]])).values() ];
                        let i = 0;
                        listEndUser.forEach(item => {
                            if(item[0] === props.itemModify.channel){
                                valueOpt.push({ value: item[1], label: item[1]});
                                i ++;
                            }
                        });
                        setListEndUser(props.itemModify.channel)
                    }
                });
                valueOpt.forEach((element)=>{
                    if (element.label===props.itemModify.name){
                        setEndUser(element.value); 
                        setListPress(element.label);
                        setPressID(props.itemModify.idPress);
                        setValueOne(props.itemModify.year);
                        setValueTwo(props.itemModify.month);
                        setValueThree(props.itemModify.lsMark);
                    }
                });
            }
        }
    };
    const checkChangeValues = (value, number) => {
        let flag = false; let check = false;
        if(number === 0){
            setMontDay(value);
            if (new Date(value.target.value).getTime() === new Date(moment(props.itemModify.endDate).format("YYYY-MM")).getTime())
                flag = true;
            if ( valueOne === props.itemModify.serie3MCClick & valueTwo === props.itemModify.serie31cClick 
                & valueThree === props.itemModify.serie32cClick & valueFour === props.itemModify.serie3EPMClick )
                check = true;
        } else if(number === 1){
            setValueOne(parseFloat(value));
            if (parseFloat(value) === props.itemModify.serie3MCClick)
                flag = true;
            if ( new Date(moment(endDate).format("YYYY-MM")).getTime() === new Date(moment(props.itemModify.endDate).format("YYYY-MM")).getTime() 
            & valueTwo === props.itemModify.serie31cClick & valueThree === props.itemModify.serie32cClick & valueFour === props.itemModify.serie3EPMClick 
            & valueFive === props.itemModify.series4BlackClick & valueSix === props.itemModify.series4OtherClick & valueSeven ===props.itemModify.series4OneShotClick & valueEight === props.itemModify.series4WhiteClick )
                check = true;
        } else if(number === 2){
            setValueTwo(parseFloat(value));
            if (parseFloat(value) === props.itemModify.serie31cClick)
                flag = true;
            if ( new Date(moment(endDate).format("YYYY-MM")).getTime() === new Date(moment(props.itemModify.endDate).format("YYYY-MM")).getTime() 
            & valueOne === props.itemModify.serie3MCClick & valueThree === props.itemModify.serie32cClick & valueFour === props.itemModify.serie3EPMClick 
            & valueFive === props.itemModify.series4BlackClick & valueSix === props.itemModify.series4OtherClick & valueSeven ===props.itemModify.series4OneShotClick & valueEight === props.itemModify.series4WhiteClick )
                check = true;
        } else if(number === 3){
            setValueThree(parseFloat(value));
            if (parseFloat(value) === props.itemModify.serie32cClick)
                flag = true;
            if ( new Date(moment(endDate).format("YYYY-MM")).getTime() === new Date(moment(props.itemModify.endDate).format("YYYY-MM")).getTime() 
            & valueOne === props.itemModify.serie3MCClick & valueTwo === props.itemModify.serie31cClick & valueFour === props.itemModify.serie3EPMClick 
            & valueFive === props.itemModify.series4BlackClick & valueSix === props.itemModify.series4OtherClick & valueSeven ===props.itemModify.series4OneShotClick & valueEight === props.itemModify.series4WhiteClick )
                check = true;
        } else if(number === 4){
            setValueFour(parseFloat(value));
            if (parseFloat(value) === props.itemModify.serie3EPMClick)
                flag = true;
            if ( new Date(moment(endDate).format("YYYY-MM")).getTime() === new Date(moment(props.itemModify.endDate).format("YYYY-MM")).getTime() 
            & valueOne === props.itemModify.serie3MCClick & valueTwo === props.itemModify.serie31cClick & valueThree === props.itemModify.serie32cClick 
            & valueFive === props.itemModify.series4BlackClick & valueSix === props.itemModify.series4OtherClick & valueSeven ===props.itemModify.series4OneShotClick & valueEight === props.itemModify.series4WhiteClick )
                check = true;
        } else if(number === 5){
            setValueFive(parseFloat(value));
            if (parseFloat(value) === props.itemModify.Series4BlackClick)
                flag = true;
            if ( new Date(moment(endDate).format("YYYY-MM")).getTime() === new Date(moment(props.itemModify.endDate).format("YYYY-MM")).getTime() 
            & valueOne === props.itemModify.serie3MCClick & valueTwo === props.itemModify.serie31cClick & valueThree === props.itemModify.serie32cClick 
            & valueFive === props.itemModify.series4BlackClick & valueSix === props.itemModify.series4OtherClick & valueSeven ===props.itemModify.series4OneShotClick & valueEight === props.itemModify.series4WhiteClick )
                check = true;
        } else if(number === 6){
            setValueSix(parseFloat(value));
            if (parseFloat(value) === props.itemModify.Series4OtherClick)
                flag = true;
            if ( new Date(moment(endDate).format("YYYY-MM")).getTime() === new Date(moment(props.itemModify.endDate).format("YYYY-MM")).getTime() 
            & valueOne === props.itemModify.serie3MCClick & valueTwo === props.itemModify.serie31cClick & valueThree === props.itemModify.serie32cClick 
            & valueFive === props.itemModify.series4BlackClick & valueSix === props.itemModify.series4OtherClick & valueSeven ===props.itemModify.series4OneShotClick & valueEight === props.itemModify.series4WhiteClick )
                check = true;
        } else if(number === 7){
            setValueSeven(parseFloat(value));
            if (parseFloat(value) === props.itemModify.Series4OneShotClick)
                flag = true;
            if ( new Date(moment(endDate).format("YYYY-MM")).getTime() === new Date(moment(props.itemModify.endDate).format("YYYY-MM")).getTime() 
            & valueOne === props.itemModify.serie3MCClick & valueTwo === props.itemModify.serie31cClick & valueThree === props.itemModify.serie32cClick 
            & valueFive === props.itemModify.series4BlackClick & valueSix === props.itemModify.series4OtherClick & valueSeven ===props.itemModify.series4OneShotClick & valueEight === props.itemModify.series4WhiteClick )
                check = true;
        } else if(number === 8){
            setValueEight(parseFloat(value));
            if (parseFloat(value) === props.itemModify.Series4WhiteClick)
                flag = true;
            if ( new Date(moment(endDate).format("YYYY-MM")).getTime() === new Date(moment(props.itemModify.endDate).format("YYYY-MM")).getTime() 
            & valueOne === props.itemModify.serie3MCClick & valueTwo === props.itemModify.serie31cClick & valueThree === props.itemModify.serie32cClick 
            & valueFive === props.itemModify.series4BlackClick & valueSix === props.itemModify.series4OtherClick & valueSeven ===props.itemModify.series4OneShotClick & valueEight === props.itemModify.series4WhiteClick )
                check = true;
        }
        
        
        if( flag & check )
            setModifyBtn(true);
        else
            setModifyBtn(false);
    };
    //vista
    return (
        <div>
            <ConfirmationModal
                id="confirmation-modal" 
                onConfirm={() => {setConfirButton(false);props.setShowModal(true);uploadAllDataButton(true);}}
                onClose={() => {setConfirButton(false);props.setShowModal(true)}}
                show={confirButton}
                title={t("requestConfirmation")}
            >
                <p>{t("requestConfirmationDescription")}</p>
            </ConfirmationModal>

            <Modal
                id="form-modal"
                onClose={setCloseModal}
                closeButton={true}
                show={props.showModal}
                title={ props.tabView === 'global_tier' ? t(props.tabView) 
                    : props.tabView === 'rate' ? "Brasil Rate" 
                    : props.tabView === "run_Length" ? "Run Length" : "LSMark"}
                footer={(
                    <div className="vn-button-group--responsive">
                        { props.valueModify ? (
                            <Button onClick={uploadAllData} disabled={modifyBtn} >{t('modify')}</Button> 
                        ) : (
                           <Button onClick={uploadAllData} disabled={!showButton} >{t('upload')}</Button> 
                        ) }
                        <Button appearance="secondary" onClick={setCloseModal}> Close </Button> 
                    </div>
                )}
            >
                { props.tabView === 'lsMark' ?  (<div />) : props.valueModify ? (<div />) : (
                    <div><label>{t('specialcondition.startdate')}</label>
                    <TextBox
                        value={dateSelected}
                        readOnly
                        disabled
                    /> <br /></div>
                )}
                { (props.valueModify) ? (setDefaultValues()) : ("") }
                { props.tabView === 'global_tier' ? props.valueModify ? (
                    <div>
                    <label>{t('specialcondition.startdate')}</label>
                    <TextBox
                        value={moment(props.itemModify.startDate).format('MM-DD-YYYY')}
                        readOnly
                        disabled
                    /> <br />
                    <label>{t('specialcondition.enddate')}</label>
                    <input 
                        className='input-date'
                        type="month"
                        value={moment(endDate).format("YYYY-MM")}
                        min={moment(props.itemModify.startDate).format("YYYY-MM")}
                        onChange={(val) => checkChangeValues(val, 0)}
                    /><label className='input-date-label' >{endDate}</label> <br />
                    <label>{t('select_channel')}</label>
                    <TextBox
                        value={ props.itemModify.channel }
                        readOnly
                        disabled
                    /> <br />
                    <label>{t('selectEndUser')}</label>
                    <TextBox
                        value={ props.itemModify.name }
                        readOnly
                        disabled
                    /> <br />
                    {props.itemModify.idPressList?(<>
                        <label>{t('pressid')}</label>
                        <TextBox
                            value={ props.itemModify.idPressList }
                            readOnly
                            disabled
                        /> <br />
                    </>):(<></>)}
                    <label>{t('series3')} MCClick</label>
                    <TextBox
                        type='number'
                        step='0.1'
                        value={valueOne}
                        onChange={(value) => checkChangeValues(value, 1)}
                        readOnly={modifyLastGT}
                    /> <br />
                    <label>{t('series3')} 1cClick </label>
                    <TextBox
                        type='number'
                        step='0.1'
                        value={valueTwo}
                        onChange={(value) => checkChangeValues(value, 2)}
                        readOnly={modifyLastGT}
                    /> <br />
                    <label>{t('series3')} 2cClick </label>
                    <TextBox
                        type='number'
                        step='0.1'
                        value={valueThree}
                        onChange={(value) => checkChangeValues(value, 3)}
                        readOnly={modifyLastGT}
                    /> <br />
                    <label>{t('series3')} EPMClick </label>
                    <TextBox
                        type='number'
                        step='0.1'
                        value={valueFour}
                        onChange={(value) => checkChangeValues(value, 4)}
                        readOnly={modifyLastGT}
                    /><br />
                    <Checkbox
                        id="series4-check"
                        label={t('enableSerie4')}
                        value={series4Check}
                        onChange={(e) => { setSeries4Check(e.target.checked) }}
                        disabled={modifyLastGT}
                    /><br />
                    {/*ALL4LABELS - props.itemModify.idEndUser=='E2201210'*/series4Check?(<>
                    <label>{t('series4')} Series4BlackClick </label>
                    <TextBox
                        type='number'
                        step='0.1'
                        placeholder="0.0"
                        disabled={endUser===undefined}
                        value={valueFive}
                        onChange={(value) => { checkChangeValues(value, 5)  }}
                        readOnly={modifyLastGT}
                    />
                    <label>{t('series4')} Series4OtherClick </label>
                    <TextBox
                        type='number'
                        step='0.1'
                        placeholder="0.0"
                        disabled={endUser===undefined}
                        value={valueSix}
                        onChange={(value) => { checkChangeValues(value, 6)  }}
                        readOnly={modifyLastGT}
                    />
                    <label>{t('series4')} Series4OneShotClick </label>
                    <TextBox
                        type='number'
                        step='0.1'
                        placeholder="0.0"
                        disabled={endUser===undefined}
                        value={valueSeven}
                        onChange={(value) => { checkChangeValues(value, 7)  }}
                        readOnly={modifyLastGT}
                    />
                    <label>{t('series4')} Series4WhiteClick </label>
                    <TextBox
                        type='number'
                        step='0.1'
                        placeholder="0.0"
                        disabled={endUser===undefined}
                        value={valueEight}
                        onChange={(value) => { checkChangeValues(value, 8)  }}
                        readOnly={modifyLastGT}
                    />
                    </>):("")}
                </div>
                ) : (
                    <div>
                        <label>{t('select_channel')}</label>
                        <Select
                            placeholder={t('selectOption')}
                            options={channelView}
                            value={[channelSelected]}
                            onClear={() => {setChannelSelected(undefined);setEndUserView([]);setEndUser(undefined);setShowButton(false);setPressCheck(false);setSeries4Check(false);}}
                            onChange={(val) => {setChannelSelected(val.value); setListEndUser(val.label); setChannel(val.label);}}
                        /> <br />
                        <label>{t('selectEndUser')}</label>
                        <Select
                            placeholder={t('selectOption')}
                            options={endUserView}
                            value={[endUser]}
                            onClear={() => {setEndUser(undefined);setShowButton(false);setSeriesData(false);setPressCheck(false);setSeries4Check(false);}}
                            onChange={(val) => {setEndUser(val.value);setUser(val.label);setSeriesData(true);setListPressEndUser(val.label);setShowButton(true);}}
                        /> <br />
                        <Checkbox
                            id="pressNeded-check"
                            label={t('specificPress')}
                            visible={endUser==undefined}
                            disabled={endUser==undefined}
                            value={pressCheck}
                            onChange={(e) => { setPressCheck(e.target.checked);  }}
                        /><br /><br />
                        {pressCheck?(<>
                            <label>{t('pressid')}</label>
                            <Select
                                placeholder={t('pressid')}
                                options={pressList}
                                value={[press]}
                                onClear={() => {setPress([]);}}
                                onChange={(val) => {setPress(val.value);}}
                            /> <br />
                        </>):(<></>)}
                        {seriesData?(
                            <>
                            <label>{t('series3')} MCClick</label>
                            <TextBox
                                type='number'
                                step='0.1'
                                placeholder="0.0"
                                disabled={endUser===undefined}
                                value={valueOne}
                                onChange={(value) => { setValueOne(value) }}
                            /> <br />
                            <label>{t('series3')} 1cClick </label>
                            <TextBox
                                type='number'
                                step='0.1'
                                placeholder="0.0"
                                disabled={valueOne===undefined | valueOne === '' | valueOne == 0}
                                value={valueTwo}
                                onChange={(value) => { setValueTwo(value) }}
                            /> <br />
                            <label>{t('series3')} 2cClick </label>
                            <TextBox
                                type='number'
                                step='0.1'
                                placeholder="0.0"
                                disabled={valueTwo===undefined | valueTwo === '' | valueTwo == 0}
                                value={valueThree}
                                onChange={(value) => { setValueThree(value) }}
                            /> <br />
                            <label>{t('series3')} EPMClick </label>
                            <TextBox
                                type='number'
                                step='0.1'
                                placeholder="0.0"
                                disabled={valueThree===undefined | valueThree === '' | valueThree == 0}
                                value={valueFour}
                                onChange={(value) => { setValueFour(value); }}
                            /><br />
                            <Checkbox
                                id="series4-check"
                                label={t('enableSerie4')}
                                value={series4Check}
                                onChange={(e) => { setSeries4Check(e.target.checked) }}
                            /><br />
                            {/*ALL4LABELS - endUser=='E2201210'*/series4Check?(<>
                                <label>{t('series4')} Series4BlackClick </label>
                                <TextBox
                                    type='number'
                                    step='0.1'
                                    placeholder="0.0"
                                    disabled={endUser===undefined}
                                    value={valueFive}
                                    onChange={(value) => { setValueFive(value);  }}
                                />
                                <label>{t('series4')} Series4OtherClick </label>
                                <TextBox
                                    type='number'
                                    step='0.1'
                                    placeholder="0.0"
                                    disabled={endUser===undefined}
                                    value={valueSix}
                                    onChange={(value) => { setValueSix(value);  }}
                                />
                                <label>{t('series4')} Series4OneShotClick </label>
                                <TextBox
                                    type='number'
                                    step='0.1'
                                    placeholder="0.0"
                                    disabled={endUser===undefined}
                                    value={valueSeven}
                                    onChange={(value) => { setValueSeven(value);  }}
                                />
                                <label>{t('series4')} Series4WhiteClick </label>
                                <TextBox
                                    type='number'
                                    step='0.1'
                                    placeholder="0.0"
                                    disabled={endUser===undefined}
                                    value={valueEight}
                                    onChange={(value) => { setValueEight(value);  }}
                                />
                            </>):("")}
                            </>
                        ):("")}
                    </div>
                ) : props.tabView === 'rate' ? (
                    <div>
                        <label> Indigo Rate: </label>
                        <TextBox
                            type='number'
                            step='0.1'
                            placeholder="0.0"
                            value={valueOne}
                            onChange={(value) => setValueOne(value) }
                        /> <br />
                        <label> Exchange Averrange: </label>
                        <TextBox
                            type='number'
                            step='0.1'
                            placeholder="0.0"
                            disabled={valueOne===undefined | valueOne == 0}
                            value={valueTwo}
                            onChange={(value) => { setValueTwo(value); setShowButton(true); setModifyBtn(false)}}
                        />
                    </div>
                ) : props.tabView === 'run_Length' ? ( 
                    <div>
                        <label>{t('select_channel')}</label>
                        {props.valueModify? (
                            <>
                                <Select
                                    placeholder={t('selectOption')}
                                    disabled
                                    options={channelView}
                                    value={[channelSelected]}
                                    onClear={()=> {setChannelSelected([]);setEndUserView([]);setEndUser(undefined);setShowButton(false);}}
                                    onChange={(val) => {setChannelSelected(val.value);setListEndUser(val.label)}}
                                /> <br />
                                
                            </>
                        ):(
                            <>
                                <Select
                                    placeholder={t('selectOption')}
                                    options={channelView}
                                    value={[channelSelected]}
                                    onClear={()=> {setChannelSelected([]);setEndUserView([]);setEndUser(undefined);setShowButton(false);}}
                                    onChange={(val) => {setChannelSelected(val.value);setListEndUser(val.label)}}
                                /> <br />
                            </>
                        )}
                        
                        <label>{t('selectEndUser')}</label>
                        {props.valueModify? (
                            <>
                                <Select
                                    placeholder={t('selectOption')}
                                    options={endUserView}
                                    disabled
                                    value={[endUser]}
                                    onClear={()=> {setPressID(undefined);setEndUser(undefined);setShowButton(false);}}
                                    onChange={(val) => {setEndUser(val.value); setListPress(val.label)}}
                                /> <br />
                                
                            </>
                        ):(
                            <>
                               <Select
                                    placeholder={t('selectOption')}
                                    options={endUserView}
                                    value={[endUser]}
                                    onClear={()=> {setPressID(undefined);setEndUser(undefined);setShowButton(false);}}
                                    onChange={(val) => {setEndUser(val.value); setListPress(val.label)}}
                                /> <br />
                            </>
                        )}
                        
                        <label>{t('press id')}</label>
                        {props.valueModify? (
                            <>
                                <Select
                                    placeholder={t('selectOption')}
                                    options={pressView}
                                    disabled
                                    value={[pressID]}
                                    onClear={()=> {setPressID(undefined);setValueOne(undefined)}}
                                    onChange={(val) => { setPressID(val.value) }}
                                /> <br />
                                
                            </>
                        ):(
                            <>
                               <Select
                                    placeholder={t('selectOption')}
                                    options={pressView}
                                    disabled={endUser===undefined}
                                    value={[pressID]}
                                    onClear={()=> {setPressID(undefined);setValueOne(undefined)}}
                                    onChange={(val) => { setPressID(val.value) }}
                                /> <br />
                            </>
                        )}
                        
                        <label>TPI</label>
                        <TextBox
                            type='number'
                            step='1'
                            placeholder="0"
                            disabled={pressID===undefined}
                            value={valueOne}
                            onChange={(value) => { setValueOne(value); 
                                if (props.valueModify){
                                    setModifyBtn(false);
                                }else{
                                    setShowButton(true);
                                }
                              
                                 }}
                        />
                    </div>
                ) : (
                    <div>
                        <label>{t('select_channel')}</label>
                        {props.valueModify? (
                            <>
                                <Select
                                    placeholder={t('selectOption')}
                                    options={channelView}
                                    disabled
                                    value={[channelSelected]}
                                    onClear={()=> {setChannelSelected([]);setEndUserView([]);setEndUser(undefined);setShowButton(false);}}
                                    onChange={(val) => {setChannelSelected(val.value);setListEndUser(val.label)}}
                                /> <br />
                                
                            </>
                        ):(
                            <>
                                <Select
                                    placeholder={t('selectOption')}
                                    options={channelView}
                                    value={[channelSelected]}
                                    onClear={()=> {setChannelSelected([]);setEndUserView([]);setEndUser(undefined);setShowButton(false);}}
                                    onChange={(val) => {setChannelSelected(val.value);setListEndUser(val.label)}}
                                /> <br />
                            </>
                        )}
                        <label>{t('selectEndUser')}</label>
                        {props.valueModify? (
                            <>
                                <Select
                                    placeholder={t('selectOption')}
                                    options={endUserView}
                                    disabled
                                    value={[endUser]}
                                    onClear={()=> {setPressID(undefined);setEndUser(undefined);setShowButton(false);}}
                                    onChange={(val) => {setEndUser(val.value); setListPress(val.label)}}
                                /> <br />
                                
                            </>
                        ):(
                            <>
                                <Select
                                    placeholder={t('selectOption')}
                                    options={endUserView}
                                    value={[endUser]}
                                    onClear={()=> {setPressID(undefined);setEndUser(undefined);setShowButton(false);}}
                                    onChange={(val) => {setEndUser(val.value); setListPress(val.label)}}
                                /> <br />
                            </>
                        )}
                        <label>{t('press id')}</label>
                        {props.valueModify? (
                            <>
                                <Select
                                    placeholder={t('selectOption')}
                                    options={pressView}
                                    disabled
                                    value={[pressID]}
                                    onClear={()=> {setPressID(undefined);setValueOne(undefined);setShowButton(false);}}
                                    onChange={(val) => { setPressID(val.value) }}
                                /> <br />
                            </>
                        ):(
                            <>
                                <Select
                                    placeholder={t('selectOption')}
                                    options={pressView}
                                    disabled={endUser===undefined}
                                    value={[pressID]}
                                    onClear={()=> {setPressID(undefined);setValueOne(undefined);setShowButton(false);}}
                                    onChange={(val) => { setPressID(val.value) }}
                                /> <br />
                            </>
                        )}
                        
                        <label>{t('year')}</label>
                        <TextBox
                            readOnly
                            value={valueOne}
                        /> <br />
                        <label>{t('month')}</label>
                        <TextBox
                            readOnly
                            value={valueTwo}
                        /> <br />
                        <label>LSMark</label>
                        <TextBox
                            type='number'
                            step='0.0001'
                            placeholder="0.0000"
                            disabled={pressID===undefined}
                            value={valueThree}
                            onChange={(value) => { setValueThree(value); if (props.valueModify){
                                setModifyBtn(false);
                            }else{
                                setShowButton(true);
                            } }}
                        />
                    </div>
                ) }
                {showNotification ? (
                    <div className="show-animated" style={{ marginTop: '28px', marginBottom: '-16px' }}>
                        <InlineNotification
                            title={notificationDetails.title}
                            type={notificationDetails.type}
                            description={notificationDetails.description}
                            onClose={() => { setShowNotification(false) }}
                        />
                    </div>
                ) : undefined}

            </Modal>
        </div>
    );
}

export default UploadModalDate;
